import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="currentColor"
    {...props}
  >
    <path
      d="M18.3149 5.37155L17.4508 4.78851C17.0948 4.54833 16.6081 4.64284 16.3654 4.99931L10.2521 14.0628L5.50565 10.8602C5.14967 10.6199 4.66303 10.7145 4.42028 11.071L3.83721 11.9351C3.59703 12.2911 3.69154 12.7777 4.048 13.0204L10.3037 17.2413C10.4832 17.3625 10.6917 17.4013 10.8878 17.3632C11.084 17.3251 11.2654 17.2106 11.384 17.0315L18.518 6.45844C18.7649 6.09588 18.6708 5.6118 18.3149 5.37155Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgTick;
